import React, { useState } from "react";
import "../../css/CRUDModal.css";
import ButtonTriangle from "../../assets/Icons/Button Triangle.png";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useForm, Controller } from "react-hook-form";
import { Box, CircularProgress } from "@mui/material";
import CustomAlert from "../../helpers/CustomAlert";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import { format, parse } from "date-fns";
import LeftCircle from "../../assets/Icons/Left circle B.png";
import RightCircle from "../../assets/Icons/Right circle A.png";
import FilterIcon from "../../assets/Icons/Orange Filter.png";
import CrossIcon from "../../assets/Icons/cross_svg.svg";

const serviceType = [
  { value: "FRANCHISE", label: "Franchise" },
  { value: "LMBP", label: "Lmbp" },
  { value: "ENTERPRISE_PARTNER", label: "Enterprise Partner" },
  { value: "COUNTER_BOOKING", label: "Counter Booking" },
];

const CustomerEnquiries = ({
  show,
  handleClose,
  setFilterData,
  filterData,
  handleReset,
  setLedgerData,
  setPageDetails,
  setNoData,
  pageSize,
  setCurrentPage,
  currentPage,
}) => {
  const {
    control,
    handleSubmit,
    setValue,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      fullName: (filterData && filterData.fullName) || "",
      type: (filterData && filterData.type) || "",
      fromDate: (filterData && filterData.fromDate) || "",
      toDate: (filterData && filterData.toDate) || "",
    },
    mode: "onChange",
  });

  const [selectedTab, setSelectedTab] = useState("Transaction Type");
  const [loading, setLoading] = useState(false);
  const loggedInUserName = sessionStorage.getItem("username");

  const handleTabChange = (e, tabName) => {
    e.preventDefault();
    setSelectedTab(tabName);
  };

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const onSubmit = (data) => {
    const formattedData = {
      ...data,
      fromDate: data.fromDate,
      toDate: data.toDate,
    };

    setFilterData(formattedData);
    setCurrentPage(1); // ✅ important
    fetchUserData(formattedData, 1); // ✅ always page 1 on filter
    handleClose();
  };

  const modifyStructure = (response, pageNo) => {
    return response?.map((user, index) => {
      const CreatedDateParsed = user?.createdAt
        ? parse(user.createdAt, "dd-MM-yyyy HH:mm:ss", new Date())
        : null;

      const formattedDateTime = CreatedDateParsed
        ? `${format(CreatedDateParsed, "dd-MM-yyyy")} ${format(
            CreatedDateParsed,
            "HH:mm:ss"
          )}`
        : "-";

      return {
        serialNumber: String(index + 1 + (pageNo - 1) * pageSize),
        type: user?.type || "-",
        fullName: user?.fullName || "-",
        city: user?.city || "-",
        mobileNumber: user?.mobileNumber || "-",
        emailId: user?.emailId || "-",
        createdAt: formattedDateTime
          ? [
              format(CreatedDateParsed, "dd-MM-yyyy"),
              <br key={index} />,
              format(CreatedDateParsed, "HH:mm:ss"),
            ]
          : ["-", <br key={index} />, "-"],
      };
    });
  };

  const fetchUserData = async (data, page) => {
    setLoading(true);
    try {
      const requestBody = {
        username: loggedInUserName,
        fullName: data.fullName || "",
        type: data.type || "",
        fromDate: formatDate(data.fromDate),
        toDate: formatDate(data.toDate),
      };

      const response = await axiosPostApi(
        `${apiList.FETCH_CUSTOMER_ENQUIRIES}?pageSize=${pageSize}&pageNo=${page}`,
        requestBody
      );

      const result = response?.data;

      if (result?.status === true && result?.respCode === "00") {
        const transactions = result?.data || [];

        if (transactions.length > 0) {
          const modifiedData = modifyStructure(transactions);
          setLedgerData(modifiedData);
          setPageDetails(result?.pageDetails);
          setNoData(false);
        } else {
          setLedgerData([]);
          setNoData(true);
          CustomAlert({
            title: "No Data",
            text: "No transactions matched the selected filters.",
            icon: "info",
            confirmButtonText: "OK",
          });
        }
      } else if (result?.respCode === "01" && result?.data === null) {
        setLedgerData([]);
        setPageDetails(null);
        setNoData(true);
        CustomAlert({
          title: "No Data",
          text: "No records found.",
          icon: "info",
          confirmButtonText: "OK",
        });
      } else {
        throw new Error(result?.message || "Unexpected response");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const onReset = () => {
    reset({
      fullName: "",
      type: "",
      fromDate: "",
      toDate: "",
    });
    setFilterData({});
    handleReset();
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "40vw",
                minWidth: "360px",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <img
                src={LeftCircle}
                alt="leftImg"
                className="absolute left-0 bottom-0 w-[110px] h-[105px]"
              />
              <img
                src={RightCircle}
                alt="leftImg"
                className="absolute right-0 top-0 w-[110px] h-[105px]"
              />
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                  justifyContent: "space-between",
                  display: "flex",
                }}
              >
                <div className="flex items-center gap-2">
                  <img src={FilterIcon} alt="filter icon" className="w-6 h-6" />
                  <h5 className="modal-title main-title font-semibold">
                    Customer Enquiries Filter
                  </h5>
                </div>
                <img
                  src={CrossIcon}
                  alt="filter icon"
                  className="w-[30px] h-[30px] cursor-pointer z-20"
                  onClick={handleClose}
                />
                {/* <HighlightOffIcon
                  onClick={handleClose}
                  style={{ cursor: "pointer" }}
                /> */}
              </div>
              <Box component="form" onSubmit={handleSubmit(onSubmit)}>
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <div className="tab-container">
                    <ul className="tab-list">
                      {["Transaction Type", "Created Date"].map((tab) => (
                        <div className="tab-wrapper" key={tab}>
                          <li
                            className={
                              selectedTab === tab
                                ? "tab-item selected"
                                : "tab-item"
                            }
                          >
                            <button
                              className={`tab-button ${
                                selectedTab === tab ? "active" : ""
                              }`}
                              onClick={(e) => handleTabChange(e, tab)}
                            >
                              {tab}
                            </button>
                          </li>
                          {selectedTab === tab && (
                            <img
                              src={ButtonTriangle}
                              alt="tri"
                              className="tab-triangle"
                            />
                          )}
                        </div>
                      ))}
                    </ul>

                    <div className="tab-content !bg-[linear-gradient(to_bottom,#FFE8D4_0%_100%,transparent_25%_100%)]">
                      {selectedTab === "Transaction Type" && (
                        <div className="dateField">
                          <label className="dateLabel">Transaction Type</label>
                          <div className="dateInputWrapper">
                            <Controller
                              name="type"
                              control={control}
                              render={({ field }) => (
                                <select
                                  {...field}
                                  className="dateInput !h-[40px]"
                                  value={field.value || ""}
                                  onChange={(e) => {
                                    field.onChange(e.target.value);
                                    setFilterData((prev) => ({
                                      ...prev,
                                      type: e.target.value,
                                    }));
                                  }}
                                >
                                  <option value="" disabled>
                                    Select Type
                                  </option>
                                  {serviceType.map((opt) => (
                                    <option key={opt.value} value={opt.value}>
                                      {opt.label}
                                    </option>
                                  ))}
                                </select>
                              )}
                            />
                          </div>
                        </div>
                      )}

                      {/* Created Date */}
                      {selectedTab === "Created Date" && (
                        <div
                          className="dateGrid"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "1rem",
                            alignItems: "flex-start",
                          }}
                        >
                          <Controller
                            name="fromDate"
                            control={control}
                            rules={{
                              validate: {
                                validDate: (value) =>
                                  !value ||
                                  !isNaN(Date.parse(value)) ||
                                  "Invalid From Date",
                                notFuture: (value) =>
                                  !value ||
                                  new Date(value) <= new Date() ||
                                  "From Date cannot be in the future",
                                beforeToDate: (value, formValues) =>
                                  !value ||
                                  !formValues.toDate ||
                                  new Date(value) <=
                                    new Date(formValues.toDate) ||
                                  "From Date must be before To Date",
                                requiredIfToDate: (value, formValues) =>
                                  !formValues.toDate ||
                                  !!value ||
                                  "From Date is required when To Date is selected",
                              },
                            }}
                            render={({ field }) => (
                              <div className="dateField" style={{ flex: 1 }}>
                                <label className="dateLabel">From Date</label>
                                <div className="dateInputWrapper">
                                  <input
                                    {...field}
                                    type="date"
                                    className="dateInput"
                                    max={getTodayDate()}
                                    onChange={(e) => {
                                      field.onChange(e);
                                      setFilterData((prev) => ({
                                        ...prev,
                                        fromDate: e.target.value,
                                      }));
                                    }}
                                  />
                                  {errors.fromDate && (
                                    <div className="error-text">
                                      {errors.fromDate.message}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          />
                          <Controller
                            name="toDate"
                            control={control}
                            rules={{
                              validate: {
                                validDate: (value) =>
                                  !value ||
                                  !isNaN(Date.parse(value)) ||
                                  "Invalid To Date",
                                notFuture: (value) =>
                                  !value ||
                                  new Date(value) <= new Date() ||
                                  "To Date cannot be in the future",
                                afterFromDate: (value, formValues) =>
                                  !value ||
                                  !formValues.fromDate ||
                                  new Date(value) >=
                                    new Date(formValues.fromDate) ||
                                  "To Date must be after From Date",
                                requiredIfFromDate: (value, formValues) =>
                                  !formValues.fromDate ||
                                  !!value ||
                                  "To Date is required when From Date is selected",
                              },
                            }}
                            render={({ field }) => (
                              <div className="dateField" style={{ flex: 1 }}>
                                <label className="dateLabel">To Date</label>
                                <div className="dateInputWrapper">
                                  <input
                                    {...field}
                                    type="date"
                                    className="dateInput"
                                    max={getTodayDate()}
                                    onChange={(e) => {
                                      field.onChange(e);
                                      setFilterData((prev) => ({
                                        ...prev,
                                        toDate: e.target.value,
                                      }));
                                    }}
                                  />
                                  {errors.toDate && (
                                    <div className="error-text">
                                      {errors.toDate.message}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "12px",
                    paddingBottom: "0px",
                    gap: "16px",
                    borderTop: "1px solid #dee2e6",
                  }}
                >
                  <div className="buttonContainer">
                    <button
                      type="button"
                      className="btn btn-back w-[133px] !rounded-lg"
                      onClick={onReset}
                    >
                      Reset
                    </button>
                  </div>
                  <div className="buttonContainer">
                    <button
                      type="submit"
                      className="btn btn-submit w-[133px] !rounded-lg"
                      disabled={isSubmitting}
                    >
                      {loading ? (
                        <CircularProgress
                          style={{ width: "20px", height: "20px" }}
                        />
                      ) : (
                        "Apply"
                      )}
                    </button>
                  </div>
                </div>
              </Box>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CustomerEnquiries;
